
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";



const initialForm = {
    view: null,
    totalCliente: 0,
    totalDistri: 0,
    totalPublicista: 0,
    totalEmpresa: 0,
    totalOrden: 0,
    iva: 0,
    quienCompra: null,
    abono: '',
    fechaEntrega: '',
    banco: '',
    imgPago: null,
};

const storeApi = (set, get) => ({
    // Estado
    formOp: initialForm,


    setFormValue: (name, value) =>
        set(state => ({
            formOp: { ...state.formOp, [name]: value }
        })),


    setFormOp: (newFormValues) =>
        set(state => ({
            formOp: { ...state.formOp, ...newFormValues }
        })),


    resetForm: () => set({ formOp: initialForm, isLoading: false }),

});

export const useFormOpStore = create()(
    devtools(
        persist(storeApi, { 
            name: "form-op",
            partialize: (state) => ({ formOp: state.formOp })
        })
    )
);

